<template>
    <v-card flex class="microCard">
        <v-card-title>
            <h3>
                Plate Map {{ requestCode }} — {{ plateMap.plate_dimensions.columns }}x{{
                    plateMap.plate_dimensions.rows
                }}
                plate
            </h3>
        </v-card-title>
        <MicroTable
            ref="microTable"
            :microData="plateMap.plates"
            :columns="plateMap.plate_dimensions.columns"
            :rows="plateMap.plate_dimensions.rows"
            :isMicrobial="true"
        />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="downloadPlateMap" color="primary">Download Plate Map</v-btn>
            <v-btn @click="cancel" color="primary">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts" setup>
import MicroTable from "@/components/Wells/MicroTable.vue";
import html2canvas from "html2canvas";
import { useTemplateRef } from "vue";

export type PlateMap = {
    plates: object[][];
    plate_dimensions: {
        rows: number;
        columns: number;
    }
}

const {
    requestCode,
    plateMap
} = defineProps<{
    requestCode: string | null;
    plateMap: PlateMap
}>();

const microTable = useTemplateRef("microTable");

const emit = defineEmits<{
    (e: 'close' ): void,
}>()

function cancel() {
    microTable.value!.setActivePlate(0);
    // this.$refs.microTable.setActivePlate(0);
    emit("close");
}

function downloadPlateMap() {
    const microTableElement = microTable.value!.$el;
    html2canvas(microTableElement).then((canvas) => {
        const link = document.createElement("a");
        link.download = `${requestCode}_plate_map.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
    });
}
</script>
